import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
type WebhookFormTitleProps = PropsWithChildren;
const WebhookFormTitle = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <QuestionMarkIcon className="fill-brand-primary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="bg-brand-primary-subtle text-text-primary flex items-center gap-5 px-6 py-3 text-base font-bold">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default WebhookFormTitle;